/* eslint-disable @typescript-eslint/no-explicit-any */
function _isEqual(value: any, other: any): boolean {
  // Check if the values are the same type
  if (typeof value !== typeof other) {
    return false;
  }

  // Handle null and undefined
  if (value === null || value === undefined || other === null || other === undefined) {
    return value === other;
  }

  // Handle primitive types
  if (typeof value !== 'object') {
    return value === other;
  }

  // Handle arrays
  if (Array.isArray(value)) {
    if (!Array.isArray(other) || value.length !== other.length) {
      return false;
    }

    for (let i = 0; i < value.length; i++) {
      if (!isEqual(value[i], other[i])) {
        return false;
      }
    }

    return true;
  }

  // Handle objects
  const valueKeys = Object.keys(value);
  const otherKeys = Object.keys(other);

  if (valueKeys.length !== otherKeys.length) {
    return false;
  }

  for (const key of valueKeys) {
    if (!isEqual(value[key], other[key])) {
      return false;
    }
  }

  return true;
}

function isEqual<T1, T2>(value: T1, other: T2) {
  return _isEqual(value, other);
}

export { isEqual };
